module.exports = __webpack_public_path__ + "static/media/xrp.84ce7542.svg";